import React, { useState, useEffect } from 'react';
import './LandingPage.css'
import { Link } from 'react-router-dom';

function LandingPage({twitterUser, setTwitterUser}) {

    const [oauthToken, setOauthToken] = useState(null);
    const urlParams = new URLSearchParams(window.location.search);
    const showTwitterSignIn = true;
    const showTestLevels = urlParams.get('showTestLevels') === 'true';
    
    const fetchTwitterToken = async () => {
        try {
            const response = await fetch("https://czi0316csk.execute-api.us-west-2.amazonaws.com/default/verifyTwitterNode", {
                method: 'POST',  // Make sure to change this to POST
            });
    
            const data = await response.json();
            if (data && data.oauth_token) {
                setOauthToken(data.oauth_token);
                console.log("Successfully set oauth token");
                if (data && data.oauth_token) {
                    sessionStorage.setItem('oauth_token_secret', data.oauth_token_secret);
                    // Redirect the user to Twitter with the obtained oauth_token
                    window.location.href = `https://api.twitter.com/oauth/authorize?oauth_token=${data.oauth_token}`;
                } else {
                    console.error("Failed to get the OAuth token.");
                }

            }
    
        } catch (error) {
            console.error("Error fetching OAuth token:", error);
        }
    };
    
    useEffect(() => {
        document.title = 'mfers beheaded';
        const urlParams = new URLSearchParams(window.location.search);
        const oauthVerifier = urlParams.get('oauth_verifier');
        const oauthToken = urlParams.get('oauth_token');
        console.log("the oauth verifier params are ", oauthVerifier);
        console.log("the oauth token params are ", oauthToken);
    
        if (oauthVerifier) {
            // Here we'll make an async call to our backend to exchange the oauthVerifier for an access token
            // Retrieve oauth_token_secret from session storage
            const oauthTokenSecret = sessionStorage.getItem('oauth_token_secret');

            const getUserIdentity = async () => {
                try {
                    const response = await fetch("https://czi0316csk.execute-api.us-west-2.amazonaws.com/default/verifyTwitterNode", {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            oauth_verifier: oauthVerifier,
                            oauth_token_secret: oauthTokenSecret,  // Include this in the request
                            oauth_token: oauthToken
 
                        })
                    });
    
                    const data = await response.json();
    
                    if (data && data.user_info && data.user_info.screen_name && data.user_info.user_id) {
                        console.log("Successfully Verified the User as ", data.user_info.screen_name);
                        setTwitterUser(data.user_info);
                        // Strip the query parameters from the URL
                        // const cleanURL = window.location.protocol + "//" + window.location.host + window.location.pathname;
                        // window.history.replaceState({}, document.title, cleanURL);
                        const currentUrl = new URL(window.location.href);
                        const searchParams = currentUrl.searchParams;
                      
                        if (searchParams.has('oauth_token') || searchParams.has('oauth_verifier')) {
                      
                          // Remove the parameters
                          searchParams.delete('oauth_token');
                          searchParams.delete('oauth_verifier');
                      
                          // Update the URL without causing a navigation event
                          window.history.replaceState({}, document.title, currentUrl.toString());
                        }
                    }
                } catch (error) {
                    console.error("Error fetching access token:", error);
                }
            };
    
            getUserIdentity();
        }
    }, []);

    const handleTwitterLogin = async () => {
        try {
            await fetchTwitterToken();
    
            if (oauthToken) {
                // Redirect the user to authenticate
                window.location.href = `https://api.twitter.com/oauth/authenticate?oauth_token=${oauthToken}`;
            }
        } catch (error) {
            console.error("Error initiating Twitter OAuth flow:", error);
        }
    };
    const handleTwitterLogout = () => {
        setTwitterUser(null);
    };    
    
    return (
      <div className="landing-page">
        <header className="App-header">
        <div className="header-content">
          <img src="/mfersbeheaded/images/heads/3.png" className="logo-image" />
          <h2>Mfers Beheaded</h2>
        </div>
        <div className="twitter-section">
          {
            twitterUser && twitterUser.screen_name ? (
                <div>
                    Welcome {twitterUser.screen_name}!
                </div>
            ) : null
          }

          {showTwitterSignIn && twitterUser === null && (
              <div>
                  <button className="twitterButton" onClick={handleTwitterLogin}>Sign In With X</button>
              </div>
          )}
          {showTwitterSignIn && twitterUser !== null && (
              <div>
                  <button className="twitterButton" onClick={handleTwitterLogout}>Sign Out X</button>
              </div>
          )}
        </div>

      </header>
        <div className="levels-container">
          <div className="level-item">
            <Link to="/leaderboard">
              <img src="/mfersbeheaded/images/leaderboard.png" alt="Leaderboard" />
            </Link>
            <p>Leaderboard</p>
          </div>
          <div className="level-item">
            <Link to="/level/1">
              <img src="/mfersbeheaded/images/declarationofcc0.webp" alt="Level 1" />
            </Link>
            <p>Mfers Jus Getting Started</p>
          </div>
          <div className="level-item">
            <Link to="/level/2">
              <img src="/mfersbeheaded/images/housesongs.png" alt="Level 2" />
            </Link>
            <p>House Songs</p>
          </div>
          <div className="level-item">
            <Link to="/level/4">
              <img src="/mfersbeheaded/images/mfa.png" alt="Level 4" />
            </Link>
            <p>Lil Mfers Playground (Kid Friendly)</p>
          </div>
          <div className="level-item nakamigocrush">
            <Link to="/pixelcrush">
              <img src="/mfersbeheaded/images/nakabg.png" alt="Pixel Crush" />
            </Link>
            <p>Pixel Crush</p>
          </div>
          <div className="level-item">
            <Link to="/tinydinos">
              <img src="/mfersbeheaded/images/tinydiners.jpeg" alt="Let's F'ing Rawr" />
            </Link>
            <p>Let's F'ing Rawr</p>
          </div>
          { showTestLevels && (
            <div className="level-item">
              <Link to="/testlevel/1">
                <img src="/mfersbeheaded/images/rain.gif" alt="Test Level 1" />
              </Link>
              <p>Test Level 1</p>
            </div>
          )}
          { showTestLevels && (
            <div className="level-item">
              <Link to="/testlevel/2">
                <img src="/mfersbeheaded/images/rain.gif" alt="Test Level 2" />
              </Link>
              <p>Test Level 2 All Lobesys</p>
            </div>
          )}
          { showTestLevels && (
            <div className="level-item">
              <Link to="/testlevel/3">
                <img src="/mfersbeheaded/images/rain.gif" alt="Test Level 3" />
              </Link>
              <p>Test Level 3 Nakamigo Crush</p>
            </div>
          )}
          <div className="level-item">
            <Link to="/about">
              <img src="/mfersbeheaded/images/rain.gif" alt="About" />
            </Link>
            <p>How To + About</p>
          </div>
        </div>
      </div>
    );
  };

  export default LandingPage;